import {
  FETCH_ALL_RECIPE_TYPES,
} from '../../mutation-types';

export default {
  [FETCH_ALL_RECIPE_TYPES](state, recipeTypes) {
    state.all = recipeTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeType/mutations.js